export default "__VITE_ASSET__BO$WtJb$__"